import {Modal} from "react-bootstrap";

const EnlargeMapModal: React.FC<{base64String: string, show: boolean, toggle: () => void}> = ({base64String, show, toggle}) => {
    return (
        <Modal show={show} onHide={toggle} dialogClassName={'modal-lg'}>
            <Modal.Header>
                <h1 className="modal-title fs-5" id="exampleModalLabel">Map</h1>
                <button onClick={toggle} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </Modal.Header>
            <Modal.Body>
                <img src={`data:image/png;base64,${base64String}`} className="w-100" alt="map"/>
            </Modal.Body>
        </Modal>
    )
}

export default EnlargeMapModal